import { useLocalStorage } from '#pplx/frontend/browser-storage/hooks/useLocalStorage.js';
import { useCallback, useMemo } from 'react';
const SOURCE_ACTIVITY_STORAGE_KEY = 'pplx_source_activity';
export const MAX_SOURCE_ACTIVITY_ENTRIES = 25;
export const useSourceActivity = () => {
    const [activity, setActivity] = useLocalStorage(SOURCE_ACTIVITY_STORAGE_KEY, []);
    const trackSourceActivity = useCallback((sourceType) => {
        setActivity((activity) => {
            const filtered = activity.filter((item) => item.sourceType !== sourceType);
            return [{ sourceType, lastUsedAt: Date.now() }, ...filtered].slice(0, MAX_SOURCE_ACTIVITY_ENTRIES);
        });
    }, [setActivity]);
    return useMemo(() => ({
        activity,
        trackSourceActivity,
    }), [activity, trackSourceActivity]);
};
//# sourceMappingURL=useSourceActivity.js.map